exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edited[data-v-45ace49d] {\n  color: #9727c9;\n}\n.edited[data-v-45ace49d]:hover {\n  color: black;\n}\n", ""]);

// exports
